import ConfigurationService from '../Service/ConfigurationService';
import { RequestConfig } from 'tree-wallet-client';
import { requestOrThrow } from '../Helper/Http';

export async function exitImpersonation(config?: RequestConfig) {
  let requestConfig = config;

  if (!requestConfig) {
    requestConfig = {
      httpConfig: {
        headers: {
          'X-Switch-User': '_exit',
        }
      }
    }
  }

  return await requestOrThrow(ConfigurationService.urls().stopImpersonationUrl, requestConfig);
}